// extracted by mini-css-extract-plugin
export default {"btnWrapper":"upload-button_btnWrapper__BMeCF","inputField":"upload-button_inputField__eSsQx","btnRipple":"upload-button_btnRipple__QEZQJ"};